<!--模板-->
<template>
  <div id="orderMoney">
    <!-- ***预约步骤 -->
    <div class="sec_order_step clearfix">
      <div class="order-step-inner mid">
        <ul>
          <li><span class="s1">STEP 01</span><span class="s2">选择陪陪服务者</span></li>
          <li class="arrow"></li>
          <li><span class="s1">STEP 02</span><span class="s2">提交服务项需求</span></li>
          <li class="arrow"></li>
          <li class="on"><span class="s1">STEP 03</span><span class="s2">支付预定金</span></li>
          <li class="arrow"></li>
          <li><span class="s1">STEP 04</span><span class="s2">等待陪陪确认</span></li>
        </ul>
      </div>
    </div>

    <!-- ***预约流程(陪行) -->
    <div class="sec_order_step_wrap mid--1000 pb--50 clearfix">
      <!-- //step 04(支付预定金)-->
      <!--申请单-->
      <div class="rt_order_list rt_order_list2">
        <h2 class="tit">预 订 申 请 单</h2>
        <div class="list_inner">
          <div class="order_detail">
            <div class="tongji"><b>需求详情</b> 行程开始({{ServeData.orderStart | time}}) - 行程结束({{ServeData.orderEnd | time}}) • {{ServeData.serveNum}}位客户</div>
            <ul>
              <li v-for="(item,index) in Number(ServeData.serveNum)" :key="item">
                <p class="guider" v-if="index == 0"><span>服务向导：<em class="c--f60">{{ServeData.serves.user.name}}</em></span></p>
                <h2 class="day">Day{{index+1}}
                  <!--<i>(2016.05.11 周三)</i>-->
                </h2>
                <span class="pos">服务城市：<a>{{ServeData.serves.serveCityStr}}</a></span>
                <div class="p1 clearfix">
                  <span class="lt fl">【{{ServeData.serves.pushTypeStr}}】{{ServeData.serves.title}}</span>
                  <em class="rt fr">CNY <b class="c--f60">{{ServeData.serves.pushPrice}}元</b></em>
                </div>
                <div class="p2 clearfix" v-if="index == Number(ServeData.serveNum)-1">
                  <span class="lt"><b>行程备注：</b></span>
                  <span class="rt">【手机号：{{ServeData.telphone}} <span v-if="ServeData.weChat != ''">微信：{{ServeData.weChat}}</span>】  • 备注：{{ServeData.remark}}</span>
                </div>
              </li>

            </ul>
          </div>
        </div>
        <div class="order_total">总价：CNY <b class="c--f60">{{ServeData.orderPrice}}元</b></div>
      </div>
      <div class="clearfix"></div>
      <div class="btn_next_step"><a class="btn_next"  @click="moneyAdd">去支付</a></div>
    </div>
  </div>
</template>


<!--JS-->
<script>
  import {selectServeOrder,codeURL} from '@/api/apis'
  export default {
    data() {
      return {
        ServeData:''
      };
    },
    methods:{
      moneyAdd(){
        let vm = this
        vm.$router.push('/orderAwait?orderNum=' + vm.$route.query.orderNum)
      }

    },
    mounted(){
      let vm = this
      // 获取订单详情
      selectServeOrder({orderNum:vm.$route.query.orderNum}).then((res)=>{
        if (res.code == '000000') {
          vm.ServeData = res.data
        } else {
          vm.$message.warning(res.msg)
        }
      })
    },
    filters:{
      time: function (value) {
        var time = new Date(value * 1000);
        function add0(m) {
          return m < 10 ? '0' + m : m
        }
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        var timeResult = y + '/' + add0(m) + '/' + add0(d)+ ' ' + add0(h) + ':' + add0(mm);
        if (timeResult == '1970-01-01' || timeResult == '1970-01-02') {
          return '--'
        } else {
          return timeResult
        }
      }
    }
  };
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  @import '../../scss/demo.scss';
  /* ==== 预约流程(陪行) {{{ ==== */
  .sec_order_step{
    background:#eaeaea;height:100px;
    box-shadow:0 1px 3px rgba(50,50,50,0.2);-webkit-box-shadow:0 1px 3px rgba(50,50,50,0.2);-moz-box-shadow:0 1px 3px rgba(50,50,50,0.2);
  }
  .sec_order_step .order-step-inner{text-align:center;}
  .sec_order_step .order-step-inner ul{display:inline-block;*display:inline;*zoom:1;}
  .sec_order_step .order-step-inner ul li{display:inline-block;vertical-align:top;margin-top:28px;height:50px;width:200px;}
  .sec_order_step .order-step-inner ul li span{color:#666;display:block;line-height:22px;}
  .sec_order_step .order-step-inner ul li.on span{color:#f60;}
  .sec_order_step .order-step-inner ul li .s1{font-size:22px;}
  .sec_order_step .order-step-inner ul li .s2{font-size:15px;margin-top:6px;}
  .sec_order_step .order-step-inner ul li.arrow{background:url(../../../static/images/icon-arrow-step.png) no-repeat center center;width:10px;}
  /* }}} */
  /*等待导游接受*/
  .sec_order_step_wrap{margin-top:30px;}
  .sec_order_step_wrap .lt_order_tips{float:left;text-align:center;width:430px;}
  .sec_order_step_wrap .lt_order_tips .success{display:inline-block;*display:inline;*zoom:1; margin-top:200px;}
  .sec_order_step_wrap .lt_order_tips .success h2{color:#666;font-size:18px;margin-top:10px;line-height:30px;}
  /*列表*/
  .sec_order_step_wrap .rt_order_list{float:right;width:650px;}
  .rt_order_list .tit{color:#666;font-size:16px;}
  .rt_order_list .list_inner{
    background:#fff;border:1px solid #ddd;margin-top:10px;
    box-shadow:0 0 5px rgba(200,200,200,0.4);-webkit-box-shadow:0 0 5px rgba(200,200,200,0.4);-moz-box-shadow:0 0 5px rgba(200,200,200,0.4);
  }
  .rt_order_list .list_inner .order_cancel{border-bottom:1px solid #ddd;padding:15px 15px 25px; position:relative;}
  .rt_order_list .list_inner .order_cancel h2{color:#666;font-size:18px;}
  .rt_order_list .list_inner .order_cancel .btn_cancel{
    background:#f8f8f8;border:1px solid #bbb;border-radius:3px;color:#333;display:block;font:14px/30px "sans-serif";margin-top:10px;text-align:center;height:30px;width:90px;
  }
  .rt_order_list .list_inner .order_cancel .btn_cancel:hover{background:#f2f2f2;}
  .rt_order_list .list_inner .order_cancel .money{text-align:right;position:absolute;top:16px;right:15px;}
  .rt_order_list .list_inner .order_cancel .money b{display:block;font-size:20px;}
  .rt_order_list .list_inner .order_cancel .money em{font-size:14px;}
  .rt_order_list .list_inner .order_detail .tongji{background:#eee;color:#999;font-size:14px;padding:15px;}
  .rt_order_list .list_inner .order_detail .tongji b{color:#333;font-size:18px;}
  .rt_order_list .list_inner .order_detail ul li{border-top:1px solid #ddd;padding:15px;}
  .rt_order_list .list_inner .order_detail ul li .guider{color:#333;font-size:18px;padding-bottom:15px;text-align:center;line-height:26px;}
  .rt_order_list .list_inner .order_detail ul li .guider span{
    background:#f8f8f8;border-radius:20px;display:inline-block;*display:inline;*zoom:1;padding:0 15px;
    box-shadow:1px 1px 3px rgba(200,200,200,0.5);-webkit-box-shadow:1px 1px 3px rgba(200,200,200,0.5);-moz-box-shadow:1px 1px 3px rgba(200,200,200,0.5);
  }
  .rt_order_list .list_inner .order_detail ul li .day{color:#333;font-size:20px;}
  .rt_order_list .list_inner .order_detail ul li .day i{color:#777;font-size:14px;}
  .rt_order_list .list_inner .order_detail ul li .pos{display:block;}
  .rt_order_list .list_inner .order_detail ul li .pos a{background:#f60;border-radius:20px;color:#fff;display:inline-block;font-size:14px;margin:5px 5px 5px 0;padding:0 10px;}
  .rt_order_list .list_inner .order_detail ul li .p1, .rt_order_list .list_inner .order_detail ul li .p2{background:#f5f5f5;color:#333;margin-top:10px;padding:10px;}
  .rt_order_list .list_inner .order_detail ul li .p1 .lt{background:url(../../../static/images/icon-basic-serv.png) no-repeat left center;padding-left:16px;}
  .rt_order_list .list_inner .order_detail ul li .p2 .lt{background:url(../../../static/images/icon-trip-beizhu.png) no-repeat left center;padding-left:20px;}
  .sec_order_step_wrap .btn_next_step{margin-top:50px;text-align:center;}
  .sec_order_step_wrap .btn_next_step .btn_next{
    background:#f60;border:1px solid #e08c00;border-radius:3px;color:#fff;cursor:pointer;display:inline-block;*display:inline;*zoom:1;font-size:18px;padding:11px 0 12px;height:auto;width:548px; box-shadow:0 1px 2px rgba(50,50,50,0.5);-webkit-box-shadow:0 1px 2px rgba(50,50,50,0.5);-moz-box-shadow:0 1px 2px rgba(50,50,50,0.5);
  }
  .sec_order_step_wrap .rt_order_list2{float:none;margin:0 auto;}
  .rt_order_list2 .tit{text-align:center;}
  .rt_order_list2 .order_total{color:#333;font-size:18px;padding:10px 20px 0 0;text-align:right;}
  .rt_order_list2 .contact_way{padding-bottom:20px;}
  .rt_order_list2 .contact_way span{display:inline-block;font-size:16px;margin-top:10px;width:325px;}

</style>



// WEBPACK FOOTER //
// src/views/order/orderMoney.vue